import React from "react";
import Menu from "../Menu/Menu";
import "./index.scss";

import { FaGithub, FaLinkedinIn, FaTelegramPlane } from "react-icons/fa";

import avatarPhoto from "../../assets/img/avatar.png";
// import resumePath from '../../assets/Duminskyi Andrii-CV.docx'
// import resumePath from '../../assets/Duminskyi Andrii-CV.pdf'
import resumePath from "../../assets/Duminskyi-CV.pdf";

const Header = ({ open, setOpen }) => {
  return (
    <header className={`header ${open ? "open" : ""}`}>
      <div className="desktop">
        <Menu />
      </div>

      <div className="header-content">
        <div className="header-photo">
          <img src={avatarPhoto} alt="Avatar" style={{ objectFit: "cover" }} />
        </div>

        <div className="header-info">
          <h2>Andrey Duminsky</h2>
          <h4>Frontend developer</h4>
        </div>

        <div className="mobileMenu">
          <Menu setOpen={setOpen} mobile />
        </div>

        <div className="social-links">
          <ul>
            <li>
              <a
                href="https://github.com/andrey-dum/"
                target="_blank"
                rel="noreferrer"
              >
                <FaGithub color="#fff" />
              </a>
            </li>
            {/* <li><a href="/" target="_blank"><FacebookIcon /></a></li> */}
            <li>
              <a href="https://t.me/andreydum" target="_blank" rel="noreferrer">
                <FaTelegramPlane color="#fff" />
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/in/andrey-duminskiy-a36ba414a/"
                target="_blank"
                rel="noreferrer"
              >
                <FaLinkedinIn color="#fff" />
              </a>
            </li>
          </ul>
        </div>
        <div className="header-buttons">
          <a
            href={resumePath}
            className="btn btn-primary"
            target="_blank"
            rel="noreferrer"
          >
            Download CV
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
